// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__jqp4N","switch_slider":"style_switch_slider__nvq2I","light":"style_light__Yj82o","dark":"style_dark__2l1ar"};